var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Footer',{staticClass:"footer"},[_c('section',{staticClass:"footer-info"},[_vm._v("\n      footerContent\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }